module.exports = __webpack_public_path__ + "static/media/RD.b9cb0bf6.webp";